<template>
	<div>
		<el-row>
			<el-col :span="24" class="bread">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item>认领记录管理</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<crud :fields="fields" :select="select" :limits="limits" apiU="Claimrecord"></crud>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				fields: [
					{
						name: 'userInfo',
						label: '用户信息',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'speciesInfo',
						label: '物种信息',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'name',
						label: '名称',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'claimRecordType',
						label: '认领类型',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'description',
						label: '说明',
						type: 'text',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				select: [
					{
						name: 'userId',
						label: '用户',
						selection: {
							data: (value)=>{
								value.splice(0,value.length);
								this.api.user.getUserList()
								.then((response)=>{
									let val=response.data.data.list.map((v)=>{
										return {
											label: v.username,
											value: v.id.toString()
										}
									});
									value.push(...val);
								})
							},
							prop: {
								label: 'label',
								value: 'value'
							}
						}
					}
				],
				limits: {
					add: false,
					delete: false,
					edit: false,
					find: true,
					export: true,
					look: true
				}
			}
		},
		methods: {
			
		},
		filters: {
			
		},
		mounted: function () {
			
		},
		computed: {
			
		}
	}
</script>

<style scoped>
	.bread{
		margin: 15px 0px;
	}
	@media screen and (min-width: 0px) and (max-width: 700px){
		.bread{
			margin: 5px 0px;
		}
	}
</style>
